/* ======================================================================== */
/* 57. SliderText */
/* ======================================================================== */
var SliderText = function ($slider) {

	if (!$slider.length) {
		return;
	}

	var
		$upper = $slider.find('.js-slider-text__upper'),
		$lower = $slider.find('.js-slider-text__lower'),
		options = {
			speed: 2000,
			slidesPerView: 'auto',
			slidesPerGroup: 1, // compatibility with Swiper 5.x
			centeredSlides: true,
			loop: true,
			touchRatio: 2,
			mousewheel: $slider.data('mousewheel-enabled') ? {
				eventsTarged: $slider.data('mousewheel-target') || '.page-wrapper',
				releaseOnEdges: true,
			} : false,
			controller: {
				by: 'container'
			},
			breakpointsInverse: true // compatibility with both Swiper 4.x and 5.x
		};

	var sliderUpper = new Swiper($upper, options);
	var sliderLower = new Swiper($lower, options);

	sliderUpper.params.breakpoints = {
		0: {
			slidesPerView: 1,
		},
		768: {
			slidesPerView: 'auto',
		}
	};

	sliderLower.params.breakpoints = {
		0: {
			slidesPerView: 1,
		},
		768: {
			slidesPerView: 'auto',
		}
	};

	sliderUpper.update();
	sliderLower.update();

	sliderUpper.controller.control = sliderLower;
	sliderLower.controller.control = sliderUpper;

}
